import { render } from "./HeaderIpBrandPreview.vue?vue&type=template&id=2279edfb&scoped=true"
import script from "./HeaderIpBrandPreview.vue?vue&type=script&lang=js"
export * from "./HeaderIpBrandPreview.vue?vue&type=script&lang=js"

import "./HeaderIpBrandPreview.vue?vue&type=style&index=0&id=2279edfb&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2279edfb"]])

export default __exports__